import * as React from 'react';
import FooterPrototype from '/react4xp/components/prototype/Footer';
import type {FooterLinkColumn, FooterLinkItem} from '/react4xp/components/prototype/Footer/types';
import type {FooterData, ResolvedFooterLinkColumn, ResolvedLink} from '/types/CommonData';

function toFooterLinkItem(link: ResolvedLink): FooterLinkItem {
    return {text: link.label, href: link.url, isExternal: link.isExternal};
}

function toFooterLinkColumn(column: ResolvedFooterLinkColumn): FooterLinkColumn {
    return {
        heading: column.heading ?? '',
        links: column.links.map(toFooterLinkItem),
    };
}

export function Footer({data}: {data?: FooterData}) {
    if (!data) {
        return null;
    }

    // Prototype defaults omitted logo to {url: '/'}; always pass url so NO/SE stay on-layer.
    const logo = {
        src: data.logoUrl ?? '',
        url: data.logoLinkUrl,
        alt: data.logoUrl ? '99x' : '',
    };

    return (
        <FooterPrototype
            logo={logo}
            address={data.address}
            email={data.email}
            phone={data.phone}
            linkColumns={data.linkColumns.map(toFooterLinkColumn)}
            legalLinks={data.legalLinks.map(toFooterLinkItem)}
        />
    );
}
